import Modal from "../../../../../components/Modal";
import { IUserAccount } from "../../../../../services/userAccountService";
import FormUserAccount from "./FormUserAccount";

interface ModalFormUserAccountProps {
  isOpen: boolean;
  toggleOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onSubmit: (value: IUserAccount | undefined) => void;
}

const ModalFormUserAccount = ({
  isOpen,
  toggleOpen,
  onSubmit,
}: ModalFormUserAccountProps) => (
  <Modal
    isOpen={isOpen}
    setOpen={toggleOpen}
    title="Tambah data - user account"
    body={
      <FormUserAccount onSubmit={onSubmit} onClose={() => toggleOpen(false)} />
    }
  />
);

export default ModalFormUserAccount;
